import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { DefaultCreditCardPaymentDetails } from '../Types/Payments/PaymentDetails';
import './index.css';
import BarnardosDonationForm from './BarnardosDonationForm';
import { WorldNetConfig } from '../Components/WorldNet/WorldNetConfig';
import { Props as HowHeardAboutUsOptions } from '../Modules/HowHeardAboutUsModule';
import { Props as DonationTypeOptions } from '../Modules/DonationTypeModule';
import Country from './Types/Country';

require('../css/materialize.css');
require('../css/butterflies-css-overrides.css');
interface Config {
    makeDonationFormConfig: {
        giftAid?: {
            enabled: boolean,
            disclaimer: string
        };

        donationAmountSelection?: {
            Header: string,
            title: string,
            disclaimer: string
        };

        product: {
            id: string,
            name: string;
            description: string;
            priceInPence: number;
            priceList: number[];
            priceListMonthly: number[];
            priceSymbol: string;
            donationTypeList: DonationTypeOptions;
            cardTypeList: string[];
            defaultCardType: string;
            defaultDonationType: string;
            paymentType: string[];
            paymentMethods: string[];
            listdonationAmount: number[];
            paymentSelection: string;
            communicationRecipient: 'PaidBy' | 'HeldBy';
            bankPaymentRadioButtonLabel: string;
            bankPaymentRadioButtonLabel2: string;
        };

        project: {
            id: string,
            title: string,
            thankYouMessage: string,
        };

        reCaptchaKey?: string;

        uiSetting: {
            progressStep: string;
        };

        termsAndConditionsText: string;

        footerText?: string;
        ddType?: string;
        creditorName?: string;
        creditorID?: string;
        creditorAddress?: string;

        communications: {
            title: string;
            introduction?: string;
            disclaimer?: string;
            groupName: string;
            description: string;
            dynamicsId: string;
        }

        postalAddressSelectorEnabled: boolean;
        commentEnabled: boolean;
        additionalCSS?: string[] | null;
        loqateValidation?: boolean;
        useIBANBIC?: boolean;
        countriesList?: Country[];
        defaultTheEndDate: boolean | null;
        campaignId?: string
        showOrganisationField?: boolean;
    };
    howHeardAboutUs: HowHeardAboutUsOptions;
    loqateKey: string;
    rhythmApiUrl: string;

    worldNet: WorldNetConfig;
    mapToCampaign?: 'HowHeardAboutUs' | 'ReasonForDonating';
}

let parseConfig = (config: Config) => {
    DefaultCreditCardPaymentDetails.cardType = config.makeDonationFormConfig.product.defaultCardType;

    if (!config.makeDonationFormConfig.product) {
        throw 'A Product is required to be configured.';
    }

    if (!config.worldNet || !config.worldNet.mpiUrl || !config.worldNet.terminalId) {
        throw 'WorldNet Config is either missing or missing values';
    }

    return {
        // Remove the trailing slash from rhythmApiUrl.
        // Important for 3DSecure, as the origin on a postMessage will not have a
        // trailing /, so without this we won't get the 3DSecure callback message.
        rhythmApiUrl: config.rhythmApiUrl.replace(/\/$/, ''),
        loqateApiKey: config.loqateKey,
        
        donationTypeDefaultId: config.makeDonationFormConfig.product.defaultDonationType,       
        donationTypeOptions: config.makeDonationFormConfig.product.donationTypeList ? config.makeDonationFormConfig.product.donationTypeList.options : [],       
        donationTypeOtherId: config.makeDonationFormConfig.product.donationTypeList ? config.makeDonationFormConfig.product.donationTypeList.otherId : '',

        donationAmountSelectionTitle: config.makeDonationFormConfig.donationAmountSelection ? config.makeDonationFormConfig.donationAmountSelection.title : '',
        donationAmountSelectionDisclaimer: config.makeDonationFormConfig.donationAmountSelection ? config.makeDonationFormConfig.donationAmountSelection.disclaimer : '',
        donationAmountSelectionHeader: config.makeDonationFormConfig.donationAmountSelection ? config.makeDonationFormConfig.donationAmountSelection.Header : '',

        product: config.makeDonationFormConfig.product,

        donationProductId: config.makeDonationFormConfig.product.id,
        project: config.makeDonationFormConfig.project || {},
        termsAndConditionsText: config.makeDonationFormConfig.termsAndConditionsText,
        addressSelectorEnabled: config.makeDonationFormConfig.postalAddressSelectorEnabled,
        reCaptchaKey: config.makeDonationFormConfig.reCaptchaKey,
        uiSetting: config.makeDonationFormConfig.uiSetting || { progressStep: 'horizontal' },

        communications: config.makeDonationFormConfig.communications,        
        howHeardAboutUsOptions: config.howHeardAboutUs.options || {},       
        howHeardAboutUsOtherId: config.howHeardAboutUs.otherId,
        howHeardAboutUsDefaultId: config.howHeardAboutUs.defaultId,
        worldNetConfig: {
            mpiUrl: config.worldNet.mpiUrl,
            terminalId: config.worldNet.terminalId,
        },
        commentEnabled: config.makeDonationFormConfig.commentEnabled,
        additionalCSS: config.makeDonationFormConfig.additionalCSS,
        loqateValidation: config.makeDonationFormConfig.loqateValidation,
        useIBANBIC: config.makeDonationFormConfig.useIBANBIC,
        countriesList: config.makeDonationFormConfig.countriesList || [],

        footerText: config.makeDonationFormConfig.footerText,
        ddType: config.makeDonationFormConfig.ddType,
        creditorName: config.makeDonationFormConfig.creditorName,
        creditorID: config.makeDonationFormConfig.creditorID,
        creditorAddress: config.makeDonationFormConfig.creditorAddress,
        defaultTheEndDate: config.makeDonationFormConfig.defaultTheEndDate ? null : config.makeDonationFormConfig.defaultTheEndDate,
        campaignId: config.makeDonationFormConfig.campaignId,
        showOrganisationField: config.makeDonationFormConfig.showOrganisationField,
        mapToCampaign: config.mapToCampaign
    };
    
};

let RenderDonateForm = (
    container: Element,
    config: Config
) => {

    let parsedConfig = parseConfig(config);    
    return ReactDOM.render(
        <BarnardosDonationForm
            rhythmApiUrl={parsedConfig.rhythmApiUrl}
            loqateApiKey={parsedConfig.loqateApiKey}

            addressSelectorEnabled={parsedConfig.addressSelectorEnabled}
            reCaptchaKey={parsedConfig.reCaptchaKey}

            product={parsedConfig.product}

            project={parsedConfig.project}
            termsAndConditionsText={parsedConfig.termsAndConditionsText}
            donationAmountSelectionTitle={parsedConfig.donationAmountSelectionTitle}
            donationAmountSelectionDisclaimer={parsedConfig.donationAmountSelectionDisclaimer}
            donationAmountSelectionHeader={parsedConfig.donationAmountSelectionHeader}
            uiSetting={parsedConfig.uiSetting}

            communications={parsedConfig.communications}
            
            howHeardAboutUsOptions={parsedConfig.howHeardAboutUsOptions}
            howHeardAboutUsOtherId={parsedConfig.howHeardAboutUsOtherId}
            howHeardAboutUsdefaultId={parsedConfig.howHeardAboutUsDefaultId}

            donationTypeOptions={parsedConfig.donationTypeOptions}
            donationTypeOtherId={parsedConfig.donationTypeOtherId}
            donationTypeDefaultId={parsedConfig.donationTypeDefaultId}

            worldNetConfig={parsedConfig.worldNetConfig}
            commentEnabled={parsedConfig.commentEnabled}
            additionalCSS={parsedConfig.additionalCSS}
            loqateValidation={parsedConfig.loqateValidation}
            useIBANBIC={parsedConfig.useIBANBIC}
            countryList={parsedConfig.countriesList}

            footerText={parsedConfig.footerText}
            ddType={parsedConfig.ddType}
            creditorName={parsedConfig.creditorName}
            creditorID={parsedConfig.creditorID}
            creditorAddress={parsedConfig.creditorAddress}
            defaultTheEndDate={parsedConfig.defaultTheEndDate}
            campaignId={parsedConfig.campaignId}
            showOrganisationField={parsedConfig.showOrganisationField}
            mapToCampaign={parsedConfig.mapToCampaign}
        />,
        container
    );
};

// tslint:disable-next-line:no-string-literal
window['RenderDonateForm'] = RenderDonateForm;


// WEBPACK FOOTER //
// ./src/MakeDonation/barnardosindex.tsx